// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartWeek_wrapper__sTO3R","list":"ChartWeek_list__4x9Zr","topic":"ChartWeek_topic__EoroW","img":"ChartWeek_img__uSpCh","topic-link":"ChartWeek_topic-link__yOIwz"};